module.exports = __webpack_public_path__ + "static/img/t13.d92f73d0.png";